export default __webpack_public_path__ + "images/D8.d91a57f.png";